import React from 'react'
import {Badge} from 'reactstrap'
import moment from 'moment'
import {Mutation} from 'react-apollo'
import {toast} from "react-toastify";
import removeProjectClientInvoiceMutation from "../../../queries/server/mutations/remove_project_client_invoice";
import downloadProjectClientInvoiceMutation from "../../../queries/server/mutations/download_project_client_invoice";
import LoadingButton from "../LoadingButton";
import removeProjectClientInvoiceLocalMutation from '../../../queries/client_side/mutations/remove_project_client_invoice'

const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
})

const ProjectSupplierInvoiceListItem = ({invoice, project_id, canDownload, canRemove, canEdit, onEdit}) => {

    const amount = invoice.breakdown.reduce((carry, {amount}) => carry += amount, 0)

    return (
        <div className="d-flex flex-column border-bottom">
            <div className="d-flex flex-row justify-content-between align-items-center p-2">
                <div className="d-flex flex-column pr-2" style={{flex: 1}}>
                    <h6>{invoice.client.name}</h6>
                    <h7>{invoice.invoice_number} <Badge
                        color={invoice.paid_at ? 'success' : 'warning'}>{invoice.paid_at ? 'Paid' : 'Outstanding'}</Badge>
                    </h7>
                    {
                        invoice.breakdown.filter(({amount}) => amount !== 0).map(({project_activity_budget, amount}) => {
                            return (<div className="d-flex flex-row justify-content-between" style={{flex: 1}}>
                                        <p className="font-weight-light p-0 m-0">{project_activity_budget.budget_label}</p>
                                        <p className="font-weight-light p-0 m-0">{format(amount)}</p>
                                    </div>)
                        })
                    }

                    <small className="text-muted">Invoice
                        Date: {moment(invoice.created_at).format('DD/MM/YYYY')}</small>
                    <small className="text-muted">Issued
                        Date: {(invoice.issued_at) ? moment(invoice.issued_at).format('DD/MM/YYYY') : '-'}</small>
                    <small className="text-muted">Paid
                        Date: {(invoice.paid_at) ? moment(invoice.paid_at).format('DD/MM/YYYY') : '-'}</small>

                </div>

                <div className="d-flex flex-row align-items-start justify-content-around">

                    <LoadingButton
                        className="square-btn mr-2"
                        icon="edit"
                        loading={false}
                        size="sm"
                        color="warning"
                        forceDisabled={!canEdit}
                        onClick={() => {
                            if(onEdit) onEdit(invoice.id)
                        }}
                    />

                    {invoice.invoice_url && <Mutation mutation={downloadProjectClientInvoiceMutation}>
                        {(downloadProjectClientInvoiceMutationFunc, {loading}) => (
                            <LoadingButton
                                className="square-btn mr-2"
                                size="sm"
                                icon="file-download"
                                loading={loading}
                                color="primary"
                                forceDisabled={!canDownload}
                                onClick={() => {
                                    downloadProjectClientInvoiceMutationFunc({variables: {url: invoice.invoice_url}})
                                        .then(({data}) => {
                                            const {downloadProjectClientInvoice} = data
                                            window.open(downloadProjectClientInvoice)
                                        })
                                }}
                            />
                        )}

                    </Mutation>}
                    <Mutation mutation={removeProjectClientInvoiceLocalMutation}>
                        {(removeProjectClientInvoiceLocalMutationFunc) => (
                            <Mutation mutation={removeProjectClientInvoiceMutation}>
                                {(removeProjectClientInvoiceMutationFunc, {loading}) => (
                                    <LoadingButton
                                        className="square-btn"
                                        size="sm"
                                        icon="trash-alt"
                                        loading={loading}
                                        color="danger"
                                        forceDisabled={!canRemove}
                                        onClick={() => {
                                            removeProjectClientInvoiceMutationFunc({variables: {id: invoice.id}})
                                                .then(() => {
                                                    toast.success('Invoice Removed', {autoClose: 2000})
                                                    removeProjectClientInvoiceLocalMutationFunc({
                                                        variables: {
                                                            invoice_id: invoice.id,
                                                            project_id
                                                        }
                                                    })
                                                })
                                                .catch(e => toast.error(e.message, {autoClose: false}))
                                        }}
                                    />
                                )}

                            </Mutation>
                        )}

                    </Mutation>
                </div>
            </div>
        </div>
    )

}

export default ProjectSupplierInvoiceListItem